import React from 'react'
import {redirectToSignedOut} from '../navigation/redirects'

export default function Home() {
  redirectToSignedOut()
}
